import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import IndividualDevelopmentPlanListView from './component';
import { accessors as idpAccessors } from 'data/IndividualDevelopmentPlans';
import { IdpStatus } from 'components/IndividualDevelopmentPlanStatus';
import { actions as groupAction } from 'containers/Group';

export const Modes = {
  GENERATE_ALL: 'generate-all',
  EXPORT_ALL: 'export-all',
};

const SHOW_EXPORT_ALL = false;

const isIdpListExist = (getState, params) => {
  const groupIdpList = idpAccessors.getGroupIdpList(getState(), params.groupId);
  const idpList = idpAccessors.getIdpList(groupIdpList, params.groupIdpId);
  return !! idpList && idpList.size > 0;
};


const isExportDisable = (getState, params) => {
  const groupIdpList = idpAccessors.getGroupIdpList(getState(), params.groupId);
  const idpList = idpAccessors.getIdpList(groupIdpList, params.groupIdpId);
  const completeList = idpList.filter((idp) =>
    idp.status.toLowerCase() === IdpStatus.COMPLETED.toLowerCase());
  return ! completeList || (completeList && completeList.size < 1);
};

const actionButtons = (getState) => ({
  Generate: {
    route: `./${Modes.GENERATE_ALL}`,
    visibleWhen: ({ params }) =>
      ! groupAction.isDisabledReportActions(getState(), params.groupId) &&
      PrivilegeChecker.hasPrivilege(
        getState(), Privileges.IndividualDevelopmentPlan.Manage) &&
      params.groupIdpId,
    isPrimary: true,
  },
  'Export All': {
    route: `./${Modes.EXPORT_ALL}`,
    visibleWhen: ({ params }) =>
      SHOW_EXPORT_ALL &&
      PrivilegeChecker.hasPrivilege(
        getState(), Privileges.IndividualDevelopmentPlan.View) &&
      isIdpListExist(getState, params),
    disableWhen: ({ params }) => isExportDisable(getState, params),
    isPrimary: true,
  },
});

export default ({ getState }) => ({
  path: ':groupIdpId(/:mode)',
  component: IndividualDevelopmentPlanListView,
  actionButtons: {
    default: actionButtons(getState),
    'export-all': actionButtons(getState),
    'generate-all': actionButtons(getState),
  },
});



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanListView/routes.js